export const uuidFtms = {
    service: "00001826-0000-1000-8000-00805f9b34fb",
    indoorBikeData: "00002ad2-0000-1000-8000-00805f9b34fb",
    fitnessMachineControlPoint: "00002ad9-0000-1000-8000-00805f9b34fb",
    fitnessMachineFeature: "00002acc-0000-1000-8000-00805f9b34fb",
    supportedResistanceRange: "00002ad6-0000-1000-8000-00805f9b34fb",
    supportedPowerRange: "00002ad8-0000-1000-8000-00805f9b34fb",
    fitnessMachineStatus: "00002ada-0000-1000-8000-00805f9b34fb",
};
